<template>
    <a
        class="block w-full mx-auto mb-8 md:mb-16 md:mx-0 md:w-64 md:w-auto"
        :href="item.url"
        data-aos="fade-up-md"
        :data-aos-delay="item.delay"
        data-aos-duration="500"
    >
        <img
            class="object-cover w-full h-48 rounded lazyload"
            :data-srcset="item.image"
            data-sizes="(min-width: 1024px) 415px, (min-width: 560px) 512px, 100vw"
            :alt="item.title"
        />

        <div class="flex-col mt-6 flex text-left">
            <h6 class="mb-3 h6 text-blue">
                <span v-for="(cat, index) in item.categories" :key="index">
                    {{ cat }}<span v-if="index !== item.categories.length - 1">, </span>
                </span>
            </h6>
            <h4 class="h5 text-blue-navy">{{ item.title }}</h4>
            <p class="mt-4 text-xs">{{ item.summary }}</p>

            <h6 class="mt-6 h6">{{ item.date }}</h6>
        </div>
    </a>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};
</script>
